import { SavingPeriod } from "@portal/types/robot/IRobotEnums";

export const MapIndexToSavingPeriod = (selectedIndex: number) => {
  let result = SavingPeriod.OnToThree;
  if (selectedIndex === 2) result = SavingPeriod.ThreeToSeven;
  else if (selectedIndex === 3) result = SavingPeriod.SevenToTen;
  else if (selectedIndex == 4) result = SavingPeriod.MoreThanTen;
  return result;
};

export const MapSavingPeriodToIndex = (savingPeriod: SavingPeriod | null) => {
  if (savingPeriod === SavingPeriod.OnToThree) return 1;
  if (savingPeriod === SavingPeriod.ThreeToSeven) return 2;
  if (savingPeriod === SavingPeriod.SevenToTen) return 3;
  if (savingPeriod === SavingPeriod.MoreThanTen) return 4;
  return null;
};
